import { Outlet, createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { SetupLayout } from '@/features/admin';
import { SETUP_PERMISSIONS } from '@/shared/auth';

/**
 * /admin/* pages are tabs of the Setup hub (Imports, Users & access, Organisation & teams, External parties, Audit log).
 * Each page keeps its own guard; this one only lets /admin (→ /setup) through for anyone who has a Setup tab. */
export const Route = createFileRoute('/_app/admin')({
  staticData: { crumb: 'nav.setup', crumbTo: '/setup' },
  beforeLoad: ({ context }) => requirePermission(context.queryClient, [...SETUP_PERMISSIONS], 'Setup'),
  component: function Admin() {
    return (
      <SetupLayout>
        <Outlet />
      </SetupLayout>
    );
  },
});
